function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";

/**
 * OtpModal - shared OTP entry modal for flows that need a second factor
 * (profile update, account closure, etc.). Both ConnectRE and WinnRE apps
 * consume this from @reloy/shared-components so the OTP UX stays consistent.
 *
 * The component is intentionally presentational: the parent app owns the API
 * calls (it has the axios instance) and passes callbacks. This keeps the
 * shared package free of app-specific networking.
 *
 * Props:
 * - open: boolean controlling visibility
 * - onClose: called when the user dismisses the modal
 * - title / description: optional heading and body text
 * - onResend: async () => void, called when the user requests a fresh OTP
 * - onVerify: async (otp) => void, called when the user submits the OTP
 * - verifyLoading: optional flag to disable the verify button (in-flight call)
 * - resendLoading: optional flag to disable the resend button (in-flight call)
 * - errorMessage: optional external error to display (e.g. API failure)
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var OtpModal = function OtpModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? "Verify OTP" : _ref$title,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? "We sent a one-time password to your registered mobile/email." : _ref$description,
    onResend = _ref.onResend,
    onVerify = _ref.onVerify,
    _ref$verifyLoading = _ref.verifyLoading,
    verifyLoading = _ref$verifyLoading === void 0 ? false : _ref$verifyLoading,
    _ref$resendLoading = _ref.resendLoading,
    resendLoading = _ref$resendLoading === void 0 ? false : _ref$resendLoading,
    errorMessage = _ref.errorMessage;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    otp = _useState2[0],
    setOtp = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    localError = _useState4[0],
    setLocalError = _useState4[1];
  if (!open) return null;
  var handleVerify = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!(otp.length < 4)) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            setLocalError("");
            _context.p = 2;
            _context.n = 3;
            return onVerify(otp);
          case 3:
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            setLocalError((_t === null || _t === void 0 ? void 0 : _t.message) || "OTP verification failed. Please try again.");
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[2, 4]]);
    }));
    return function handleVerify() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleResend = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            setLocalError("");
            _context2.p = 1;
            _context2.n = 2;
            return onResend();
          case 2:
            _context2.n = 4;
            break;
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            setLocalError((_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || "Failed to send OTP. Please try again.");
          case 4:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function handleResend() {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_jsx("div", {
    className: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50",
    children: /*#__PURE__*/_jsxs("div", {
      className: "w-full max-w-sm rounded-lg bg-white p-6 shadow-lg",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-between",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "text-lg font-semibold",
          children: title
        }), /*#__PURE__*/_jsx("button", {
          onClick: onClose,
          className: "text-gray-400 hover:text-gray-600",
          "aria-label": "Close",
          children: "\xD7"
        })]
      }), description && /*#__PURE__*/_jsx("p", {
        className: "mt-2 text-sm text-gray-600",
        children: description
      }), /*#__PURE__*/_jsx("div", {
        className: "mt-4",
        children: /*#__PURE__*/_jsx("input", {
          type: "text",
          inputMode: "numeric",
          maxLength: 6,
          value: otp,
          onChange: function onChange(e) {
            return setOtp(e.target.value.replace(/\D/g, ""));
          },
          placeholder: "Enter OTP",
          className: "w-full rounded-md border border-gray-300 px-3 py-2 focus:border-blue-500 focus:outline-none"
        })
      }), (localError || errorMessage) && /*#__PURE__*/_jsx("p", {
        className: "mt-2 text-sm text-red-600",
        children: localError || errorMessage
      }), /*#__PURE__*/_jsxs("div", {
        className: "mt-4 flex items-center justify-between gap-3",
        children: [/*#__PURE__*/_jsx("button", {
          onClick: handleResend,
          disabled: resendLoading || verifyLoading,
          className: "rounded-md bg-gray-200 px-4 py-2 text-sm text-gray-800 hover:bg-gray-300 disabled:bg-gray-100 disabled:text-gray-400 disabled:opacity-100 disabled:cursor-not-allowed",
          children: resendLoading ? "Sending..." : "Resend OTP"
        }), /*#__PURE__*/_jsx("button", {
          onClick: handleVerify,
          disabled: otp.length < 4 || verifyLoading,
          className: "rounded-md bg-primary text-white px-4 py-2 text-sm font-medium hover:opacity-90 disabled:bg-gray-300 disabled:text-gray-500 disabled:opacity-100 disabled:cursor-not-allowed",
          children: verifyLoading ? "Verifying..." : "Verify"
        })]
      })]
    })
  });
};
export default OtpModal;